import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AuthService } from 'src/app/services/auth/auth.service';
import { MessageCenterService } from 'src/app/services/message-center.service';
import { Severity } from 'src/app/types/misc/Severity';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { LoggedOutLayoutComponent } from '../logged-out-layout/logged-out-layout.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: true,
  imports: [
    SHARED_IMPORTS,
    LoggedOutLayoutComponent,
    ButtonModule,
    RouterModule
  ]
})
export class ForgotPasswordComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);
  private messageCenterService = inject(MessageCenterService);
  private translate = inject(TranslateService);

  forgetPasswordForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  ngOnInit(): void {
    this.forgetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit() {
    if (this.forgetPasswordForm && this.forgetPasswordForm.valid) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const email = this.forgetPasswordForm.get('email')?.value;
      this.authService.generatePasswordLinkWeb(email).subscribe((response) => {
        if (response) {
          this.router.navigate(['/login']);
          this.showForgotPasswordToast('success');
        }
      });
    }
  }

  showForgotPasswordToast(severity: Severity): void {
    this.messageCenterService.showToast(
      this.translate.instant(
        `forgetPasswordComponent.toasts.${severity}.summary`
      ),
      this.translate.instant(
        `forgetPasswordComponent.toasts.${severity}.detail`
      ),
      severity
    );
  }
}
